import {
  HttpClient,
  HttpEvent,
  HttpHeaders,
  HttpParams,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  private _token?: string = undefined;
  private _tokenChanged: boolean | undefined = undefined;


  private headers?: HttpHeaders = undefined;

  constructor(private http: HttpClient) { }

  get<T>(
    uri: string,
    queryParams: Record<string, string | number | boolean> | null = null,
  ): Observable<T> {
    const url = this.getUrl(uri, queryParams);
    return this.http.get<T>(url).pipe(
      catchError(this.handleError)
    );
  }

  getWithParams<T>(
    uri: string,
    queryParams: Record<string, any> = {},
  ): Observable<T> {
    const url = this.getUrl(uri);
    let params = new HttpParams();
    Object.keys(queryParams).forEach((key) => {
      if (queryParams[key] !== null) {
        params = params.set(key, queryParams[key].toString());
      }
    });
    return this.http.get<T>(url, {
      headers: this.getHeaders(),
      params: params,
    });
  }

  post<X, T>(uri: string, objet: X): Observable<T> {
    let body = null;
    if (objet != null) {
      body = JSON.stringify(objet);
    }
    const url = this.getUrl(uri);
    return this.http.post<T>(url, body).pipe(
      catchError(this.handleError)
    );
  }

  postFiles(uri: string, objet: any) {
    let body = objet;
    const url = this.getUrl(uri);
    return this.http.post(url, body, {
      reportProgress: true,
      observe: 'events',
    }).pipe(
      catchError(this.handleError)
    );
  }

  put<X, T>(uri: string, objet: X): Observable<T> {
    let body = null;
    if (objet != null) {
      body = JSON.stringify(objet);
    }
    const url = this.getUrl(uri);
    return this.http.put<T>(url, body).pipe(
      catchError(this.handleError)
    );
  }

  delete<T>(uri: string): Observable<T> {
    const url = this.getUrl(uri);
    return this.http.delete<T>(url).pipe(
      catchError(this.handleError)
    );
  }

  request(
    methode: string,
    uri: string,
    formData: FormData,
  ): Observable<HttpEvent<unknown>> {
    const url = this.getUrl(uri);
    const req = new HttpRequest(methode, url, formData, {
      reportProgress: true,
    });
    return this.http.request(req);
  }

  openFile(uri: string): Observable<any> {
    const url = this.getUrl(uri);
    return this.http.get(url, { responseType: 'blob', observe: 'body' }).pipe(
      catchError(this.handleError)
    );
  }
  downloadFile(uri: string): Observable<any> {
    const url = this.getUrl(uri);
    return this.http.get(url, {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json' },
      observe: 'response',
    }).pipe(
      catchError(this.handleError)
    );
  }

  downloadFilePost2<T>(uri: string, objet: T): Observable<any> {
    const url = this.getUrl(uri);
    return this.http.post(url, objet, {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json' },
      observe: 'response',
    });
  }

  downloadFilePost<T>(uri: string, objet: T): Observable<ArrayBuffer> {
    const url = this.getUrl(uri);
    return this.http.post(url, objet, {
      responseType: 'arraybuffer',
      headers: { 'Content-Type': 'application/json' },
      observe: 'body',
    });
  }

  getUrl(
    uri: string,
    queryParams: Record<string, string | number | boolean> | null = null,
  ): string {
    let query = '';
    if (queryParams != null) {
      query += '?';
      let index = 0;
      const indexMax = Object.keys(queryParams).length - 1;
      for (const key in queryParams) {
        if (queryParams.hasOwnProperty(key)) {
          if (queryParams[key] != null) {
            query += key + '=' + queryParams[key];
            if (index < indexMax) {
              query += '&';
            }
          }
          index++;
        }
      }
    }
    return environment.exploreURL + '/api/' + uri + query;
    //return window.location.origin+'/api/' + uri + query;
  }

  public setToken(token: string) {
    this._token = token;
    this._tokenChanged = true;
  }

  private getHeaders(): HttpHeaders {
    if (!this.headers || this._tokenChanged) {
      this.headers = new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this._token}`,
      });
      this._tokenChanged = false;
    }
    return this.headers;
  }


  private handleError(error: any): Observable<never> {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // Server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(() => new Error(errorMessage)); // Updated to new syntax
  }
}
